export const MBC_ASSESSMENT_EMERGENCY_WARNING = 'Endorsed suicide: risk assessment and safety plan required'
